export default "__VITE_ASSET__a50139f8__"